import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { EMAIL, MAILTO, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, REGIONS, SERVICES, TAGLINE } from "@/constants/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0B1F17]">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:px-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-3">
          <img
            src="/logo-official.png"
            alt="Barnala Labour Contracting logo"
            data-testid="footer-logo-image"
            className="h-11 w-11 rounded-full object-cover"
          />
          <span className="leading-tight">
            <span className="block font-display text-lg font-bold tracking-tight">BARNALA</span>
            <span className="block font-mono text-[10px] font-medium uppercase tracking-[0.3em] text-[#86EFAC]/80">
              Labour Contracting
            </span>
          </span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#F6F4EE]/60">
          Dependable farm, greenhouse and cannery labour crews serving British Columbia's South Coast.
        </p>
        <p data-testid="footer-tagline" className="mt-4 font-display text-base italic text-[#86EFAC]">
          “{TAGLINE}”
        </p>
      </div>

      <div>
        <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#86EFAC]">Explore</h3>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                data-testid={`footer-${link.testId}`}
                className="text-sm text-[#F6F4EE]/70 transition-colors hover:text-[#86EFAC]"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#86EFAC]">Services</h3>
        <ul className="mt-5 space-y-3">
          {SERVICES.map((s) => (
            <li key={s.id}>
              <Link
                to="/services"
                data-testid={`footer-service-${s.id}`}
                className="text-sm text-[#F6F4EE]/70 transition-colors hover:text-[#86EFAC]"
              >
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
        <div className="mt-6 flex flex-wrap gap-2">
          {REGIONS.map((r) => (
            <span
              key={r.id}
              className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1 text-xs text-[#F6F4EE]/70"
            >
              <MapPin className="h-3 w-3 text-[#86EFAC]" />
              {r.name}
            </span>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#86EFAC]">Contact</h3>
        <a
          href={PHONE_TEL}
          data-testid="footer-call-link"
          className="mt-5 flex items-center gap-3 text-sm text-[#F6F4EE]/80 transition-colors hover:text-[#86EFAC]"
        >
          <Phone className="h-4 w-4 shrink-0 text-[#22C55E]" />
          {PHONE_DISPLAY}
        </a>
        <a
          href={MAILTO}
          data-testid="footer-email-link"
          className="mt-4 flex items-center gap-3 text-sm text-[#F6F4EE]/80 transition-colors hover:text-[#86EFAC]"
        >
          <Mail className="h-4 w-4 shrink-0 text-[#22C55E]" />
          {EMAIL}
        </a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-[#F6F4EE]/40 sm:flex-row sm:px-10">
        <span>© {new Date().getFullYear()} Barnala Labour Contracting. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.2em]">Lower Mainland · Fraser Valley · Greater Vancouver</span>
      </div>
    </div>
  </footer>
);
